export enum AuthenticationMethod {
  NONE = 'None',
  BASIC = 'Basic',
}
